import { GoogleGenAI } from "@google/genai";
import type { FormData } from '../types';

// The Vite build process will replace `process.env.API_KEY` with the actual key from the Vercel environment variable VITE_API_KEY.
const API_KEY = process.env.API_KEY;

if (!API_KEY) {
  // Updated error message for clarity
  console.error("Gemini API key is not set. Please set the VITE_API_KEY environment variable in your Vercel deployment settings.");
}

// Initialize the AI client. The SDK will throw an error if the key is invalid, which will be caught below.
const ai = new GoogleGenAI({ apiKey: API_KEY });

export const generateDocumentStream = async function* (
  documentTypeName: string,
  formData: FormData
): AsyncGenerator<string> {
  // Add a clear, user-facing check here to fail fast if the key is missing.
  if (!API_KEY) {
    yield `\n\n--- حدث خطأ أثناء إنشاء المستند: API key is missing. Please provide a valid API key. ---`;
    return;
  }

  const { businessName, websiteUrl, email, businessDescription, language, tone } = formData;

  const prompt = `
Generate a comprehensive and professional ${documentTypeName} in ${language} language.

Company Information:
- Company Name: ${businessName}
- Website: ${websiteUrl}
- Email: ${email}
- Business Description: ${businessDescription}

Requirements:
- The tone of voice should be: ${tone}.
- write a complete, professional legal document.
- write legal document using headlines and paragraphs only, No bulleted lists, No numbered lists, and No checklists.
- Include all necessary sections and clauses.
- Use appropriate legal terminology.
- Make it comprehensive and detailed.
- Format as plain text with proper structure.
- Include proper disclaimers and legal notices.
- Ensure compliance with general legal standards.
- Do not include symbols like "#" or "*".
- The final generated content should not exceed 550 words.

Please generate only the document text without any additional formatting or explanations. The legal document should only contains headlines and paragraphs, No bulleted lists, No numbered lists, and No checklists.
  `;

  try {
    const response = await ai.models.generateContentStream({
      model: 'gemini-2.5-flash',
      contents: prompt,
    });

    for await (const chunk of response) {
      const text = chunk.text;
      if (text) {
        yield text;
      }
    }
  } catch (error) {
    console.error("Error generating document with Gemini API:", error);
    if (error instanceof Error) {
        yield `\n\n--- حدث خطأ أثناء إنشاء المستند: ${error.message} ---`;
    } else {
        yield "\n\n--- حدث خطأ غير معروف أثناء إنشاء المستند. ---";
    }
  }
};
